import { createStore } from 'vuex'

import communications from './modules/communications'
import contacts from './modules/contacts'
import consents from './modules/consents'
import notes from './modules/notes'
import substudies from './modules/substudies'

export default createStore({
    modules: {
        communications,
        contacts,
        consents,
        notes,
        substudies
    }
})